import MazeRenderDebug from "../maze/MazeRenderDebug.js";

export default class AutoWalkthrough {
	constructor(tileMap, path, showDebug, model, callback) {
		this.tileMap = tileMap;
		this.path = path;
		this.showDebug = showDebug;
		this.model = model;
	}

	init() {
		return
		if (this.showDebug) {
			this.renderDebug = new MazeRenderDebug(this.model, jQuery(".js-maze"));
			this.renderDebug.init();
		}
		
		this.indexPath = -1;
		this.showNextStep(this.path);
	}


	showNextStep(path) {
		this.indexPath++;
		if (this.indexPath < path.length) {
			let cell = path[this.indexPath];
			this.tileMap.goto(cell);
			this.tileMap.showWalkthrough(cell);
			if (this.renderDebug) {
				jQuery(".js-path", cell.mc).show();
			}
			setTimeout(this.showNextStep.bind(this, path), 100);
		} else {
			this.dispatch({ type: AutoWalkthrough.EVENT_MAZE_TRAVERSED_OK });
		}
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

}

AutoWalkthrough.EVENT_MAZE_TRAVERSED_OK = "eventMazeTraversedOk";


